/* eslint no-console: 0 */
import * as utils from "../utils/index";
import Logger from "../Logger";

const Levels = {
  DEBUG: 4,
  INFO: 3,
  WARN: 2,
  ERROR: 1,
  OFF: 0
};

export default class ConsoleLogger extends Logger {
  constructor(level) {
    if (typeof level === 'string') {
      level = Levels[level.toUpperCase()];
    }
    super(typeof level === 'number' ? level : Levels.DEBUG);
  }

  error(fmt, ...args) {
    if (this._level < Levels.ERROR) {
      return;
    }
    const isoDate = new Date().toISOString();
    const result = utils.format(fmt, ...args);
    console.log(isoDate, 'ERROR', result);
  }

  warn(fmt, ...args) {
    if (this._level < Levels.WARN) {
      return;
    }
    const isoDate = new Date().toISOString();
    const result = utils.format(fmt, ...args);
    console.log(isoDate, 'WARN', result);
  }

  info(fmt, ...args) {
    if (this._level < Levels.INFO) {
      return;
    }
    const isoDate = new Date().toISOString();
    const result = utils.format(fmt, ...args);
    console.log(isoDate, 'INFO', result);
  }

  debug(fmt, ...args) {
    if (this._level < Levels.DEBUG) {
      return;
    }
    const isoDate = new Date().toISOString();
    const result = utils.format(fmt, ...args);
    console.log(isoDate, 'DEBUG', result);
  }
}
